import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { push } from 'react-router-redux';
import t from 'tcomb-form';
import { objectToFormData } from '../../utils/index';
import CityAutosuggestFactory from '../../components/CityAutosuggest';
import { doUpdateSharedStory, doUploadSharedStoryPhoto } from '../../actions';
import { WebsiteRefinement, WebsiteTransformer } from '../../utils/tcomb-utils';
import SharedStoryPhoto from './SharedStoryPhoto';

const sharedStoryPhotoProportion = .666;

const SharedStorySchema = t.struct({
  share_facebook: t.maybe(WebsiteRefinement),
  share_linkedin: t.maybe(WebsiteRefinement)
});

const formOptions = {
  auto: 'none',
  legend: <p className="legend-shareSocials">May we share the links to your social profiles with your Story?<br />If yes, please enter the your links below.</p>,
  fields: {
    share_facebook: {
      label: "Facebook link",
      transformer: WebsiteTransformer,
      attrs: {

      }
    },
    share_linkedin: {
      label: "Linkedin link",
      transformer: WebsiteTransformer,
      attrs: {

      }
    },
  }
};


class SharedStoryStep3 extends Component {
  constructor(props) {
    super(props);
  }

  state = {
    formOptions: formOptions,
    formValues: {},
    photoWrapperWidth: null,
    photoWrapperHeight: null
  }

  onFormChange = formValues => {
    this.setState({ formValues });
  }

  handleSubmit = (e) => {
    e.preventDefault();
    const value = this.refs.sharedStoryForm.getValue();
    if (!value) {
      return;
    } else {
      //let content = objectToFormData(value);
      var content = Object.assign({}, value);
      content.pk = this.props.sharedStory.db_id;

      this.props.doUpdateSharedStory(content);

      if (typeof(Window) !== "undefined") {
        window.scrollTo(0,0)
      }

      this.props.goToStep4();

      this.resetForm();
    }
  }

  resetForm = (e) => {
    this.setState({formValues: {
      share_facebook: '',
      share_linkedin: ''
    }})
  }

  componentWillReceiveProps(nextProps) {
    let wrapperWidth = document.getElementById('photoWrapper').clientWidth;

    let wrapperHeight = 0;

    // Set max width
    if (wrapperWidth >= 638) {
      wrapperWidth = 638;
      wrapperHeight = 425;
    } else {
      wrapperHeight = Math.round(wrapperWidth * sharedStoryPhotoProportion);
    }

    this.setState({
      photoWrapperWidth: wrapperWidth,
      photoWrapperHeight: wrapperHeight
    });
  }

  render(){
    let user = this.props.auth.user;

    return(
      <div className="sharedStory-innerWrapper sharedStory-step2Wrapper">

        <div className="sharedStory-progressbar">
          <img src="/images/shared_stories/apply_step02.png" />
        </div>

        <div className="sharedStoryWrapper sharedStoryWrapper-formWrapper">
          <form encType="multipart/form-data" className="shared-story-form" onSubmit={(e)=>{ e.prevenDetault(); }}>
          <t.form.Form ref="sharedStoryForm" value={this.state.formValues} onChange={this.onFormChange} type={SharedStorySchema} options={this.state.formOptions} />
          </form>
        </div>

        <div id="photoWrapper" className="sharedStoryWrapper sharedStoryWrapper-photo">

          <p>We would love if you can share with us a photo of yourself holding up the WorldWideWomen sign! Please upload a landscape (wide rather than tall) photo (see below).</p>

          <SharedStoryPhoto picture={this.props.sharedStory.www_photo}
          pk={this.props.sharedStory.db_id}
          imgWidth={this.state.photoWrapperWidth}
          imgHeight={this.state.photoWrapperHeight}
          style={{width: this.state.photoWrapperWidth+'px', height: this.state.photoWrapperHeight+'px'}}
          onChanged={this.props.doUploadSharedStoryPhoto}/>

          <div className="sharedStoryFormBtnWrapper">
            <button onClick={this.handleSubmit} className="my-account-submit submitButton button-primary" type="submit">Submit</button>&nbsp;
            <button onClick={this.reset} className="submitButton " type="reset">Reset</button>
          </div>
        </div>


      </div>
    );
  }
}

function mapStateToProps(state) {
  return state;
};

export default connect(
  mapStateToProps,
  {
    push,
    doUpdateSharedStory,
    doUploadSharedStoryPhoto
  }
)(SharedStoryStep3);



// WEBPACK FOOTER //
// ./src/components/sharedStory/SharedStoryStep3.jsx